<template>
  <div class="row">
    <div class="span8 list-main">
      <h1 class="list-title">岗位<small>{{ tag ? '标签：' + tag : '' }}</small></h1>
      <ul class="tabs-nav">
        <li :class="{ active: pagelistquery.lable === '' }" @click="changelable('')">全部</li>
        <li v-if="tag" :class="{ active: tagActive }" @click="tagActive = true">{{ tag }}</li>
        <li v-for="item in lables" :key="item" :class="{ active: pagelistquery.lable === item }" @click="changelable(item)">{{ item }}</li>
      </ul>
      <ul class="articles">
        <li class="article-entry" v-for="item in tableData" :key="item.job_id" style="position: relative;">
          <h4 class="entry-title" style="padding-right: 120px;">
            <router-link :to="`/jobcontent/${item.job_id}`">{{ item.job_name }}</router-link>
          </h4>
          <div class="entry-meta">
            <span>🕐 {{ item.job_createtime | dataFormat }}</span>
            <span>🏢 {{ item.company_name }}</span>
          </div>
          <h4 style="position: absolute; right: 4px; top: 14px; color: #e60000; font-size: 16px;">{{ item.job_salary }}</h4>
        </li>
      </ul>
      <div class="pagination-wrap">
        <el-pagination
          layout="prev, pager, next"
          :total="pagelistquery.total"
          :page-size="10"
          @current-change="getlist"
        ></el-pagination>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <company-widget />
    </div>
  </div>
</template>

<script>
import carouselWidget from '@/components/carousel.vue'
import companyWidget from '@/components/company.vue'
import { getJobList, getLable } from '@/api'

export default {
  name: 'Job',
  components: { carouselWidget, companyWidget },
  props: { tag: { type: String, default: '' } },
  data() {
    return {
      lables: [],
      tagActive: true,
      tableData: [],
      pagelistquery: { lable: '', tag: this.tag || '', page: 1, total: 0 }
    }
  },
  created() {
    getLable('招聘分类').then((res) => {
      this.lables = JSON.parse(res.data[0].lable) || []
    })
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      this.pagelistquery.page = page
      getJobList({ ...this.pagelistquery, pagesize: 10 }).then((res) => {
        this.tableData = res.data || []
        this.pagelistquery.total = res.count || 0
      })
    },
    changelable(lable) {
      this.pagelistquery.lable = lable
      this.tagActive = false
      this.getlist(1)
    }
  }
}
</script>
